module.exports = __webpack_public_path__ + "img/powered-safety.c9dbe26d.svg";